import $http from '../../axios';
import { Notification } from 'element-ui';

function notifyError(message) {
    Notification.error({
        title: 'Error!',
        message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box',
    });
}

// Reutiliza el mismo endpoint que el módulo roles (GET /api/rol) para poblar el selector de rol.
export async function fetchRoles({ commit }) {
    await $http.get('/api/rol')
        .then((response) => commit('setRoles', response.data))
        .catch((error) => notifyError(error.message));
}

// Catálogo completo de indicadores sin importar el rol (check=false en todos, deshabilitados en el
// template). Se usa al entrar a la vista, ANTES de elegir un rol — las secciones/checks deben verse
// siempre, no solo después de seleccionar uno — y también al quitar el rol del selector (clearable).
export async function fetchCatalog({ commit }) {
    commit('setLoading', true);

    await $http.get('/api/role-dashboard-permissions')
        .then((response) => commit('setPermissions', response.data.data))
        .catch((error) => notifyError(error.message))
        .finally(() => commit('setLoading', false));
}

// Selecciona un rol y carga su catálogo de permisos de indicadores del dashboard. Sin rol, vuelve
// al catálogo genérico (fetchCatalog) en vez de vaciar la grilla: las secciones quedan siempre
// visibles.
export async function selectRole({ commit, dispatch }, roleId) {
    commit('setSelectedRoleId', roleId);

    if (!roleId) {
        await dispatch('fetchCatalog');
        return;
    }

    commit('setLoading', true);

    await $http.get('/api/role-dashboard-permissions', { params: { role_id: roleId } })
        .then((response) => commit('setPermissions', response.data.data))
        .catch((error) => notifyError(error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message))
        .finally(() => commit('setLoading', false));
}

// Guarda (reemplaza) el catálogo completo de permisos del rol seleccionado.
export async function savePermissions({ commit, state }) {
    if (!state.selectedRoleId) {
        notifyError('Debe seleccionar un rol');
        return;
    }

    commit('setSaving', true);

    const payload = {
        role_id: state.selectedRoleId,
        permissions: state.permissions.map(p => ({ name: p.name, check: !!p.check }))
    };

    await $http.put('/api/role-dashboard-permissions', payload)
        .then((response) => {
            commit('setPermissions', response.data.data);
            Notification.success({
                title: 'Exito!',
                message: 'Los permisos del dashboard se han guardado correctamente',
                type: 'success',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
        .catch((error) => notifyError(error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message))
        .finally(() => commit('setSaving', false));
}



// WEBPACK FOOTER //
// ./src/modules/role-dashboard-permissions/actions.js